import { SvgStyled } from '../../../components/Global/Atomics/SvgStyled';

const Environment = (props) => {
    return (
        <SvgStyled
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            className={props.cssClasses ? `icon ${props.cssClasses}` : 'icon'}
            viewBox="0 0 40 40"
            width={props.size}
            height={props.size}>
            <path fillRule="evenodd" clipRule="evenodd"
                d="M20 3C20.5523 3 21 3.44772 21 4V6.34793C21.9724 5.52153 23.2146 5.01218 24.5314 5.00959C25.7889 5.00712 27.0635 5.00333 27.9964 5.00001L29 4.99644V10C29 12.7614 26.7614 15 24 15H21V21.3891C21.987 20.5415 23.2516 20.0173 24.5882 20.0152C26.4805 20.0122 28.5613 20.0056 29.9961 20L31 19.9961V28C31 30.7614 28.7614 33 26 33H21V36C21 36.5523 20.5523 37 20 37C19.4477 37 19 36.5523 19 36V21H16C13.2386 21 11 18.7614 11 16V10.9964L12.0036 11C12.9365 11.0033 14.2111 11.0071 15.4686 11.0096C16.7854 11.0122 18.0276 11.5215 19 12.3479V4C19 3.44772 19.4477 3 20 3ZM21 13H24C25.6569 13 27 11.6569 27 10V7.00331C26.2446 7.00564 25.3861 7.00792 24.5354 7.00959C22.6748 7.01324 21 8.68344 21 10.5336V13ZM19 16.5336C19 14.6834 17.3252 13.0132 15.4646 13.0096C14.6139 13.0079 13.7554 13.0056 13 13.0033V16C13 17.6569 14.3431 19 16 19H19V16.5336ZM21 31H26C27.6569 31 29 29.6569 29 28V22.0037C27.6842 22.0083 26.0797 22.0129 24.5914 22.0152C22.7102 22.0182 21 23.7215 21 25.5904V31Z"
                fill={props.color ? props.color : "white"} />
        </SvgStyled>
    );
};

export default Environment;
